import { Fragment, useEffect, useState } from "react";
export default function PlayerPlace({place}){
    const [playerPlace,setPlayerPlace] = useState(place)
    useEffect(()=>{
        setPlayerPlace(place);
    },
    [place]);
    const parsePosition = (n) => {
        let pos = undefined;
        if(n === 1){
            pos = `${n}st`;
        }
        else if(n === 2){
            pos = `${n}nd`;
        }
        else if(n === 3){
            pos = `${n}rd`;
        }
        else{
            pos = `${n}th`;
        }
        return pos + " place";
    }
    return (
        <Fragment>
            <h1>{ playerPlace === -1 ? '' : parsePosition(playerPlace) }</h1>
        </Fragment>
    );
}